import { Instagram, Youtube, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { PROFILE } from "../data";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative z-10 border-t border-[#2C223A] py-12 px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        <img
          src="/ovidiu-logo.png"
          alt="Ovidiu"
          className="h-12 w-auto object-contain"
        />

        <div className="flex items-center gap-4" data-testid="footer-socials">
          <a
            href={PROFILE.socials.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            aria-label="Instagram"
            className="w-14 h-14 rounded-full border border-[#D6B56D]/30 flex items-center justify-center text-[#A59DAB] hover:text-[#06040A] hover:bg-[#D6B56D] hover:border-[#D6B56D] transition-all duration-300"
          >
            <Instagram size={24} />
          </a>
          <a
            href={PROFILE.socials.youtube}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-youtube"
            aria-label="YouTube"
            className="w-14 h-14 rounded-full border border-[#D6B56D]/30 flex items-center justify-center text-[#A59DAB] hover:text-[#06040A] hover:bg-[#D6B56D] hover:border-[#D6B56D] transition-all duration-300"
          >
            <Youtube size={24} />
          </a>
        </div>

        <div className="flex flex-col items-center md:items-end gap-3">
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            aria-label="Admin"
            title="Admin"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D6B56D]/40 text-[#D6B56D] text-xs uppercase tracking-[0.2em] hover:bg-[#D6B56D] hover:text-[#06040A] transition-all duration-300"
          >
            <Lock size={13} /> Admin
          </Link>
          <p className="text-xs uppercase tracking-[0.25em] text-[#D6B56D]/80">
            {PROFILE.tagline}
          </p>
          <p className="text-xs text-[#A59DAB]">
            © {new Date().getFullYear()} · Made with soul
          </p>
        </div>
      </div>
    </footer>
  );
};
